module.exports = __webpack_public_path__ + "static/media/CashApp.510c40b2.png";